import { parseISO } from '@core/date.facade';

export function parseISOWithFallback(date: string, fallbackValue = null): Date {
    try {
        return date ? parseISO(date) : fallbackValue;
    } catch (e) {
        return fallbackValue;
    }
}
